import { useRef } from "react";
import {changeBtn,changeBtnErr,selectShinGroup,} from "../../store/Slices/ShinGroupSlice/shinSlices";
import { useDispatch, useSelector } from "react-redux";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const btnRef = useRef(null);
  const thanksP = useRef(null);
  const emailRef = useRef(null);
  const dispatch = useDispatch();
  const { contactBtn} = useSelector(selectShinGroup);

  const sendEmail = (ev) => {
    ev.preventDefault();

    const serviceId = "service_ssk6s44";
    const publicKey = "-usQUM5_CZZI9I2oT";
    const templateId = "template_tau6mva";

    const {
      user_name: { value: user_name },
      user_email: { value: user_email },
      message: { value: message },
    } = ev.target;

    const templateParams = {
      from_name: user_name,
      from_email: user_email,
      message,
    };

     emailjs
       .send(serviceId, templateId, templateParams, publicKey)
       .then((response) => {
        //  console.log("succses");
       })
       .catch((error) => {
         console.log(error);
       });

    btnRef.current.classList.add("noneBtn");
    thanksP.current.classList.add("blockP");

    ev.target.reset();
  };

  const seeValue = (ev) => {
    const txt = ev.target.value;
    if (
      txt.includes("@gmail.com") ||
      txt.includes("@gmail.am") ||
      txt.includes("@mail.ru") ||
      txt.includes("@mail.am") ||
      txt.includes("@mail.com") ||
      txt.includes("@bk.ru") ||
      txt.includes("@inbox.") ||
      txt.includes("@Yahoo.")
    ) {
      dispatch(changeBtn(txt));
    } else {
      dispatch(changeBtnErr());
      thanksP.current.classList.remove("blockP");
    }
  };

  const seeValues = (ev) => {
    const txt = ev.target.value;
    if (
      txt.includes("@gmail.com") ||
      txt.includes("@gmail.am") ||
      txt.includes("@mail.ru") ||
      txt.includes("@mail.am") ||
      txt.includes("@mail.com") ||
      txt.includes("@bk.ru") ||
      txt.includes("@inbox.") ||
      txt.includes("@Yahoo.")
    ) {
      emailRef.current.textContent = "Ձեր Email";
      emailRef.current.style.color = "black";
    } else {
      emailRef.current.style.color = "red";
      emailRef.current.textContent = "Տեսակը սխալ է *";
    }
  }
  

  return (
    <div>
      <form className="formEmail" onSubmit={sendEmail}>
        <div className="formArea">
          <label htmlFor="user_name">Անուն</label>
          <input
            type="text"
            name="user_name"
            id="user_name"
            required
            className="nameClient"
            placeholder="Վահան"
            maxLength={15}
          />
        </div>
        <div className="formArea">
          <label ref={emailRef} htmlFor="user_email">
            Ձեր Email
          </label>
          <input
            type="email"
            name="user_email"
            id="user_email"
            onBlur={seeValues}
            onChange={seeValue}
            required
            maxLength={34}
            placeholder="egohyan.shin@gmail.com"
          />
        </div>
        <div className="formArea">
          <label htmlFor="message">Նամակ</label>
          <textarea
            id="message"
            required
            name="message"
            rows="2"
            cols="50"
            className="textArea"
            maxLength={250}
            placeholder="Եկեք խոսենք այն մասին..."
          ></textarea>
        </div>
        {contactBtn ? (
          <button ref={btnRef} className="formBtn">
            Ուղարկել Նամակ
          </button>
        ) : (
          <button className="formBtn changeValue">Ուղարկել</button>
        )}
        <p ref={thanksP} className="thanks">
          Շնորհակալություն մեզ հետ կապվելու համար !
        </p>
      </form>
    </div>
  );
};

export default ContactForm;
